module.exports = __webpack_public_path__ + "media/landing_page/personal_path-4cdf165a.png";